<div class="spinner" *ngIf="isShowSpinner">
    <div class="spinner--img">
        <img src="/assets/img/components/spinner/spinner.png" alt="Please wait while data is loading">
    </div>
    <p class="spinner--title">Please wait while data is loading</p>
    <p class="spinner--subtitle">It can take some time</p>
</div>
